import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, LOCALE_ID } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { registerLocaleData } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import localeEs from '@angular/common/locales/es'
import { MAT_DIALOG_DATA } from '@angular/material'

import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt'
import { AngularFireAuth } from 'angularfire2/auth'

import { AgmCoreModule, LazyMapsAPILoaderConfigLiteral } from '@agm/core'

import { AppComponent } from './app.component'

import { FrameworkModule } from './framework/framework.module'
import { AuthService } from './framework/auth/auth.service'
import { AuthLoadGuard, AuthActivateGuard, AuthActivateChildGuard } from './framework/auth/auth.guard'
import { ApiService } from './framework/data/api.service'
import { FIREBASE_SETTINGS } from './framework/data/firebase.settings.token'
import { SignInComponent } from './framework/auth/sign-in/sign-in.component'

import { GoogleMapsConfig } from '../config/config';
// import { AvatarModule } from 'ngx-avatar';



registerLocaleData(localeEs, 'es')

const routes: Routes = [
  {
    path: '',
    loadChildren: 'app/front/front.module#FrontModule'
  },
  {
    path: 'customer',
    loadChildren: 'app/front-others/front-others.module#FrontOthersModule'
  },
  {
    path: 'business',
    loadChildren: 'app/front-business/front-business.module#FrontBusinessModule'
  },
  {
    path: 'secured',
    data: { permissions: [AuthService.ACCESS_PERMISSION] },
    loadChildren: 'app/secure/secure.module#SecureModule',
    canLoad: [ AuthLoadGuard ],
    canActivate: [ AuthActivateGuard ],
    canActivateChild: [ AuthActivateChildGuard ],
  },
  {
    path: 'signin',
    component: SignInComponent
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
]

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    AgmCoreModule.forRoot(GoogleMapsConfig as LazyMapsAPILoaderConfigLiteral),
    FrameworkModule,
    HttpClientModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: ApiService.authHttpFactory,
        deps: [AngularFireAuth, FIREBASE_SETTINGS],
      },
    }),
    // AvatarModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
